export default "__VITE_ASSET__B$re0HHF__"